/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import classNames from 'classnames';
import { Tooltip } from '../react/tooltip';
import { messages as Messages } from './messages';

// Component for an individual rule's row
class EventReachRowItem extends React.Component {
  constructor(...args) {
    super(...args);
    this.render = this.render.bind(this);
    this.ignoreClick = this.ignoreClick.bind(this);
  }

  render() {
    const {
      rule
    } = this.props;
    const {
      result
    } = this.props;

    const classes = classNames({
      item: true,
      item_failed:    result === 'failed',
      item_partial:   result === 'partial',
      item_satisfied: result === 'satisfied',
      item_ignored:   result === 'ignored'
    });

    const rule_label = (Messages[rule] != null ? Messages[rule].label : undefined) || `[missing label: ${rule}]`;
    const result_check_class = classNames({
      fa: true,
      'fa-check-circle': result === 'satisfied',
      'fa-times-circle': result === 'failed',
      'fa-circle-o': (result !== 'satisfied') && (result !== 'failed')
    });

    const tooltip = (Messages[rule] != null ? Messages[rule].tooltip : undefined) && ((Messages[rule] != null ? Messages[rule].tooltip : undefined) !== '') ?
      <Tooltip text={Messages[rule].tooltip} />
    :
      null;

    return <div className={classes}>
      <h3>
        <span>
          <i className={result_check_class}></i>
          {' '}
          {rule_label}
          {tooltip}
        </span>
      </h3>
    </div>;
  }

  ignoreClick(ev) {
    ev.preventDefault();
    return false;
  }
}

// Main EventReach React component
//
// This is the main component that displays the eventreach list
export class EventReachComponent extends React.Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this._scoreChanged = this._scoreChanged.bind(this);
    this.render = this.render.bind(this);

    this.state = {
      score: this.props.eventReach.result.score,
      max: this.props.eventReach.result.max,
      rules: this.props.eventReach.result.rules,
      visible: this.props.eventReach.visible,
      can_trend: this.props.eventReach.can_trend
    };

    this.ordered_rules = _((() => {
      const result = [];
      for (const key in Messages) {
        const value = Messages[key];
        result.push([key, value.order]);
      }
      return result;
    })())
      .sortBy(i => i[1])
      .map(i => i[0]);
  }

  componentDidMount() {
    return this.props.eventReach.on('change', this._scoreChanged);
  }

  componentWillUnmount() {
    return this.props.eventReach.removeListener('change', this._scoreChanged);
  }

  // Update state based on scoring change
  _scoreChanged() {
    return this.setState({
      score: this.props.eventReach.result.score,
      max: this.props.eventReach.result.max,
      rules: this.props.eventReach.result.rules,
      visible: this.props.eventReach.visible,
      can_trend: this.props.eventReach.can_trend
    });
  }

  render() {
    let result; let rule;
    let rows;
    rows = [];
    // Create rows for the defined rules in order
    for (rule of Array.from(this.ordered_rules)) {
      result = this.state.rules[rule];
      if ((result == null) || (result === 'disabled')) { continue; }
      rows.push(<EventReachRowItem rule={rule} result={result} key={rule}/>);
    }

    // And then, append any extra results to the bottom
    for (rule in this.state.rules) {
      result = this.state.rules[rule];
      if (Array.from(this.ordered_rules).includes(rule)) { continue; }
      if (result === 'disabled') { continue; }
      rows.push(<EventReachRowItem rule={rule} result={result} key={rule}/>);
    }

    const contents = (() => {
      if (this.state.visible) {
      const percent = Math.round((this.state.score / this.state.max) * 100);
      return <div className="percent">
        <div className="progress_wrapper">
          <div className="progress" style={{width: `${percent  }%`}}>&nbsp;</div>
        </div>
        <p><a href="#" data-action="toggle" data-target="#x-eventreach-item-list">{percent}% Reach</a></p>
      </div>;
    } 
      rows = [];
      return <div>
        <p>EventReach Unavailable</p>
        <p>Because this event has limited visibility, it will not be very discoverable by your audience. If you would like this event to be more easily discovered, change its visibility setting.</p>
      </div>;
    
    })();

    //;// EventReach block
    return <div className="widget">
      <h2 className="widget-header">EventReach <a className="more_info_link" href="https://help.concept3d.com/hc/en-us/articles/11938388753043-EventReach-EventScore" title="Click here to learn more about EventReach">?</a></h2>
      <div className="widget-content widget-eventreach">
        {contents}
        <div className="eventreach-item-list" id="x-eventreach-item-list">
          {rows}
        </div>
      </div>
    </div>;
  }
}
